export const AgentLineGenerateVideo = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.10235 2.70117H18.9023C20.5592 2.70117 21.9023 4.04432 21.9023 5.70117V18.3012C21.9023 19.958 20.5592 21.3012 18.9023 21.3012H12.0023H5.10234C3.44549 21.3012 2.10234 19.958 2.10234 18.3012L2.10235 5.70117C2.10235 4.04432 3.44549 2.70117 5.10235 2.70117Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M10.5 14.5977V9.40234L15 12L10.5 14.5977Z" fill="currentColor" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
